import React, { useMemo } from 'react';
import Select from 'react-select';


const Dropdown = ({ options, clearable, isMulti, disabled, customStyle, value, setValue, placeholder, label, errorFields, name }) => {
    const selectOptions = useMemo(() => options.map((option) => (
        typeof option === 'object' && option !== null
            ? { label: option.label, value: option.value }
            : { label: option, value: option }
    )), [options]);

    let style = customStyle || {}
    return (<>
        <label style={{ display: 'flex', marginTop: '15px', fontSize: '16px', color: '#000', ...style }}>{label || ''}</label>
        <Select
            isMulti={!!isMulti}
            isDisabled={disabled}
            className={errorFields.includes(name) ? 'basic-single-error' : "basic-single"}
            classNamePrefix="select"
            isClearable={!!clearable}
            placeholder={placeholder || ''}
            value={value}
            options={selectOptions}
            onChange={setValue}
        />
    </>)
}

export default Dropdown
